import { Component, h } from 'preact'
import Header from '../header'
import Panel from '../panel'
import ButtonControl from '../button-control'
import globals from '../../utils/globals'
import TextButton from '../ui-components/TextButton'

interface Props {
  ssoProxyUrl: string
}

interface State {}

class SAMLSetup extends Component<Props, State> {
  metadataUrl: string

  constructor (props: Props) {
    super(props)
    this.metadataUrl = `${props.ssoProxyUrl}saml/metadata?customer=${globals('communityId')}`
    this.downloadMetadata = this.downloadMetadata.bind(this)
    this.copyMetadataUrl = this.copyMetadataUrl.bind(this)
  }

  downloadMetadata () {
    window.open(this.metadataUrl)
  }

  copyMetadataUrl () {
    const tmp = document.createElement('textarea')
    tmp.value = this.metadataUrl
    document.body.appendChild(tmp)
    tmp.select()
    document.execCommand('copy')
    document.body.removeChild(tmp)
  }

  render (props: Props, state: State) {
    return (
      <div class='saml-setup'>
        <Header
          title='SAML'
          disableCancelButton
          disableSaveButton
          hasBreadcrumb
          breadcrumbText='Back to SSO overview'
          breadcrumbLink='/settings/sso'
        />
        <Panel
          title='SAML setup'
          class='sso-settings'
        >
          <div className='form-enumeration'>
            <div className='form-enumeration__number'>1</div>
            <div className='form-enumeration__step-title'>Download metadata using the button below</div>
            <div className='form-enumeration__step-line' />
            <div>
              <ButtonControl
                class='form-enumeration__step-content download-saml-metadata'
                onClick={this.downloadMetadata}
                title='Download metadata'
              />
              <TextButton
                class='copy-download-link'
                onClick={this.copyMetadataUrl}
              >
                Copy the download link
              </TextButton>
            </div>
            <div className='form-enumeration__number'>2</div>
            <div className='form-enumeration__step-title form-enumeration__step-title--red'>
              Configure identity provider information using metadata
            </div>
          </div>
        </Panel>
      </div>
    )
  }
}

export default SAMLSetup
